import React from "react";
import {IPaginationMeta} from "../_apiResponse";

type PaginationProps = {
    data: IPaginationMeta,
    changePage: (page: number) => void
}

export default function Pagination({data, changePage }: PaginationProps)
{
    const lastPage = data.last_page;
    const currPage = data.current_page;
    const prev = currPage - 1;
    const next = currPage + 1;

    const renderPages = () => {
        const pages = [];
        for (let i = 1; i <= lastPage; i++) {
            pages.push(
                <li key={i} className={"page-item "+(currPage === i ? "active" : "") }>
                    <button type="button" onClick={() => { changePage(i) }} className="btn-link page-link">{ i }</button>
                </li>
            );
        }
        return pages;
    };

    return (
        <ul className="pagination">
            <>
                <li className={"page-item previous "+(currPage === 1 ? "disabled" : "")}>
                    <button type="button" onClick={() => { changePage(prev) }} className="btn-link page-link">
                        <i className="previous"></i>
                    </button>
                </li>

                {renderPages()}

                <li className={"page-item next "+(currPage === lastPage ? "disabled" : "")}>
                    <button type="button" onClick={() => { changePage(next) }} className="btn-link page-link">
                        <i className="next"></i>
                    </button>
                </li>
            </>
        </ul>
    );
}
